import { render, staticRenderFns } from "./feedBackDetail.vue?vue&type=template&id=191fe77c&scoped=true"
import script from "./feedBackDetail.vue?vue&type=script&lang=js"
export * from "./feedBackDetail.vue?vue&type=script&lang=js"
import style0 from "./feedBackDetail.vue?vue&type=style&index=0&id=191fe77c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191fe77c",
  null
  
)

export default component.exports